<!-- @format -->

<div
  class="dialog-max cdialog overlay"
  style="min-width: 600px; height: calc(80vh - 48px)"
>
  <div class="dialogHeader">
    <div mat-dialog-title>{{_common.thinkdesks.set_schedule}}</div>
    <div class="spacer"></div>
    <div (click)="cancel()" class="closeButton">
      <fa-icon icon="times"></fa-icon>
    </div>
  </div>

  <mat-dialog-content>
    <div class="max-height ">
      <form [formGroup]="form" class="max-scroll dialogBody space-y-4">
        <div class="card">
          <div class="cardBody">
            <app-form-field style="margin-right: 10px">
              <app-label>{{_common.thinkdesks.from}}</app-label>
              <input
                matInput
                [matDatepicker]="startDate"
                formControlName="startDate"
                [placeholder]="_common.thinkdesks.from_placeholder"
              />
              <mat-datepicker-toggle
                appSuffix
                [for]="startDate"
              ></mat-datepicker-toggle>
              <mat-datepicker #startDate></mat-datepicker>
            </app-form-field>
  
            <app-form-field style="margin-right: 10px">
              <app-label>{{_common.thinkdesks.to}}</app-label>
              <input
                matInput
                [matDatepicker]="endDate"
                formControlName="endDate"
                [placeholder]="_common.thinkdesks.to_placeholder"
              />
              <mat-datepicker-toggle
                appSuffix
                [for]="endDate"
              ></mat-datepicker-toggle>
              <mat-datepicker #endDate></mat-datepicker>
            </app-form-field>

          </div>
          
        </div>

        <!-- <div>{{_common.thinkdesks.schedule_info}}</div> -->
        <div class="card">
          <div class="cardBody">
            <app-booking-calendar-day
              [form]="$any(form.controls['mon'])"
              [title]="_common.thinkdesks.mon"
              #mon
            >
              <fa-icon
                icon="clone"
                [matMenuTriggerFor]="applyMenu"
                (menuOpened)="_open(form.controls['mon'])"
              ></fa-icon>
            </app-booking-calendar-day>
          </div>
          <div class="cardDivider"></div>
          <div class="cardBody">
  
            <app-booking-calendar-day
              [form]="$any(form.controls['tue'])"
              [title]="_common.thinkdesks.tue"
              #tue
            >
              <fa-icon
                icon="clone"
                [matMenuTriggerFor]="applyMenu"
                (menuOpened)="_open(form.controls['tue'])"
              ></fa-icon>
            </app-booking-calendar-day>
          </div>
          <div class="cardDivider"></div>
          <div class="cardBody">
            <app-booking-calendar-day
              [form]="$any(form.controls['wed'])"
              [title]="_common.thinkdesks.wed"
              #wed
            >
              <fa-icon
                icon="clone"
                [matMenuTriggerFor]="applyMenu"
                (menuOpened)="_open(form.controls['wed'])"
              ></fa-icon>
            </app-booking-calendar-day>
          </div>
          <div class="cardDivider"></div>
          <div class="cardBody">
  
            <app-booking-calendar-day
              [form]="$any(form.controls['thu'])"
              [title]="_common.thinkdesks.thu"
              #thu
            >
              <fa-icon
                icon="clone"
                [matMenuTriggerFor]="applyMenu"
                (menuOpened)="_open(form.controls['thu'])"
              ></fa-icon>
            </app-booking-calendar-day>
          </div>
          <div class="cardDivider"></div>
          <div class="cardBody">
  
            <app-booking-calendar-day
              [form]="$any(form.controls['fri'])"
              [title]="_common.thinkdesks.fri"
              #fri
            >
              <fa-icon
                icon="clone"
                [matMenuTriggerFor]="applyMenu"
                (menuOpened)="_open(form.controls['fri'])"
              ></fa-icon>
            </app-booking-calendar-day>
          </div>
          <div class="cardDivider"></div>
          <div class="cardBody">
            <app-booking-calendar-day
              [form]="$any(form.controls['sat'])"
              [title]="_common.thinkdesks.sat"
              #sat
            >
              <fa-icon
                icon="clone"
                [matMenuTriggerFor]="applyMenu"
                (menuOpened)="_open(form.controls['sat'])"
              ></fa-icon>
            </app-booking-calendar-day>
          </div>
          <div class="cardDivider"></div>
          <div class="cardBody">
            <app-booking-calendar-day
              [form]="$any(form.controls['sun'])"
              [title]="_common.thinkdesks.sun"
              #sun
            >
              <fa-icon
                icon="clone"
                [matMenuTriggerFor]="applyMenu"
                (menuOpened)="_open(form.controls['sun'])"
              ></fa-icon>
            </app-booking-calendar-day>
          </div>
          <div class="cardDivider"></div>
          <div class="cardBody">
            <div class="flex">
              <div class="mr-4">
                {{_common.thinkdesks.public_holiday_open}}
              </div>
              <mat-slide-toggle formControlName="usePh" #_usePh>
                <span
                  *ngIf="_usePh.checked;
                  else _usePhnotSelected"
                >
                  {{_common.thinkdesks.Yes}}
                </span>
                <ng-template #_usePhnotSelected>
                  <span>{{_common.thinkdesks.No}}</span>
                </ng-template>
              </mat-slide-toggle>
            </div>
  
            <app-booking-calendar-day
              *ngIf="form.value.usePh"
              [form]="$any(form.controls['ph'])"
              [title]=""
              #ph
            >
              <!-- <fa-icon
                icon="clone"
                [matMenuTriggerFor]="applyMenu"
                (menuOpened)="_open(form.controls['ph'])"
              ></fa-icon> -->
            </app-booking-calendar-day>
          </div>

        </div>


      </form>
    </div>
  </mat-dialog-content>
  <div class="dialogBar">
    <div class="spacer"></div>
    <button class="app-btn" (click)="save()" color="primary">
      {{_common.save}}
    </button>
  </div>
</div>

<mat-menu #applyMenu="matMenu">
  <div (click)="$event.stopPropagation()">
    <div style="line-height: 48px; padding: 0 16px">
      {{_common.thinkdesks.copy_to}}
    </div>
    <div mat-menu-item>
      <mat-checkbox (click)="_toggle()"></mat-checkbox
      >{{_common.thinkdesks.select_all}}
    </div>
    <div mat-menu-item>
      <mat-checkbox [(ngModel)]="_mon"></mat-checkbox>
      {{_common.thinkdesks.mon}}
    </div>
    <div mat-menu-item>
      <mat-checkbox [(ngModel)]="_tue"></mat-checkbox>
      {{_common.thinkdesks.tue}}
    </div>
    <div mat-menu-item>
      <mat-checkbox [(ngModel)]="_wed"></mat-checkbox>
      {{_common.thinkdesks.wed}}
    </div>
    <div mat-menu-item>
      <mat-checkbox [(ngModel)]="_thu"></mat-checkbox>
      {{_common.thinkdesks.thu}}
    </div>
    <div mat-menu-item>
      <mat-checkbox [(ngModel)]="_fri"></mat-checkbox>
      {{_common.thinkdesks.fri}}
    </div>
    <div mat-menu-item>
      <mat-checkbox [(ngModel)]="_sat"></mat-checkbox>
      {{_common.thinkdesks.sat}}
    </div>
    <div mat-menu-item>
      <mat-checkbox [(ngModel)]="_sun"></mat-checkbox>
      {{_common.thinkdesks.sun}}
    </div>
  </div>
  <div mat-menu-item>
    <button
      class="app-btn"
      color="primary"
      (click)="applyTemplate()"
      style="width: 100%"
    >
      {{_common.save}}
    </button>
  </div>
</mat-menu>
